import { render, staticRenderFns } from "./allOrder.vue?vue&type=template&id=0b5c6c79&"
import script from "./allOrder.vue?vue&type=script&lang=js&"
export * from "./allOrder.vue?vue&type=script&lang=js&"
import style0 from "./allOrder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports